var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Title from '../../../atoms/Title';
import { VerticalGap } from '../../../atoms/Gap/Gap';
import Desc from '../../../atoms/Desc';
import Input from '../../../atoms/Input';
import CtaBtn from '../../../atoms/CtaBtn';
import { neutralDay, hanghae } from '@teamsparta/design-system';
import { emailAtom, readWriteModalHistoryAtom } from '../../../../stores';
import { useAtom } from 'jotai/index';
import { checkEmail, validateEmail } from '../../../../businessLogics';
import AlertText from '../../../atoms/AlertText';
import { BottomContents, MainContents } from '../../../../styles/_common.style';
import { useIsMobile } from '../../../../businessLogics/hooks';
import { getIsEmailDuplicate, useEmailAuth } from '../../../../businessLogics/apis';
var ChangeEmailEnter = function () {
    var _a = useAtom(emailAtom), email = _a[0], setEmail = _a[1];
    var _b = useState(null), emailWarning = _b[0], setEmailWarning = _b[1];
    var _c = useState(false), isEmailSendable = _c[0], setIsEmailSendable = _c[1];
    var _d = useAtom(readWriteModalHistoryAtom), _ = _d[0], updateHistory = _d[1];
    var isMobile = useIsMobile();
    var requestEmailDuplicateCheck = function (email) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getIsEmailDuplicate(email)];
                case 1:
                    result = _a.sent();
                    if (result.ok) {
                        if (!result.is_exist) {
                            if (result.is_kko_exist) {
                                setEmailWarning('카카오 계정으로 가입한 이메일입니다.');
                            }
                            else {
                                return [2, true];
                            }
                        }
                        else {
                            setEmailWarning('이미 사용 중인 이메일입니다.');
                        }
                    }
                    return [2];
            }
        });
    }); };
    useEffect(function () {
        setIsEmailSendable(validateEmail(email));
    }, [email]);
    var emailAuth = useEmailAuth(setEmailWarning);
    var onClickCta = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = checkEmail(email, setEmailWarning);
                    if (!_a) return [3, 2];
                    return [4, requestEmailDuplicateCheck(email)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    if (_a) {
                        emailAuth.mutate({ email: email });
                    }
                    return [2];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 90 }, { children: [_jsx(Title, { children: "\uC774\uBA54\uC77C \uBCC0\uACBD" }), _jsx(VerticalGap, { size: isMobile ? 8 : 12 }), _jsxs(Desc, { children: ["\uC774\uBA54\uC77C\uC744 \uBC14\uAFB8\uB824\uBA74 \uC778\uC99D\uC774 \uD544\uC694\uD574\uC694.", _jsx("br", {}), "\uC544\uB798 \uC785\uB825\uD55C \uACC4\uC815\uC73C\uB85C \uC778\uC99D\uBC88\uD638\uB97C \uBCF4\uB0B4\uB4DC\uB9B4\uAC8C\uC694."] }), _jsx(VerticalGap, { size: isMobile ? 20 : 40 }), _jsx(Input, { value: email, setValue: setEmail, placeHolder: '변경할 이메일 입력', onClickCta: onClickCta }), _jsx(AlertText, __assign({ isShow: !!emailWarning, color: hanghae.red100 }, { children: emailWarning })), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), _jsx(CtaBtn, __assign({ isInactive: !isEmailSendable, bgColor: isEmailSendable ? neutralDay.gray100 : '#1416174d', color: neutralDay.white, onClickAction: onClickCta }, { children: "\uC778\uC99D\uBC88\uD638 \uBC1B\uAE30" }))] }))] })), isMobile && (_jsx(BottomContents, { children: _jsx(CtaBtn, __assign({ isInactive: !isEmailSendable, bgColor: isEmailSendable ? neutralDay.gray100 : '#1416174d', color: neutralDay.white, onClickAction: onClickCta }, { children: "\uC778\uC99D\uBC88\uD638 \uBC1B\uAE30" })) }))] }));
};
export default ChangeEmailEnter;
//# sourceMappingURL=ChangeEmailEnter.js.map